import {request} from '@/network/request'

//资源库图片
export function getResourceBasePicture() {
  return request({
    url: '/gaoligong/picturevideo/getResourceBasePicture',
    method: 'get'
  })
}
export function getPictureVideoFileList() {
  return request({
    url: '/gaoligong/picturevideo/getPictureVideoFileList',
    method: 'post'
  })
}


